exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Error-module__error-screen___3Bg7s{display:flex;justify-content:center;align-items:center;height:calc(var(--app-height) - 60px);padding:60px}.Error-module__error-screen___3Bg7s .Error-module__wrapper___mB-zW{display:flex;flex-direction:column;align-items:center}.Error-module__error-screen___3Bg7s .Error-module__wrapper___mB-zW img{width:500px;max-width:100%;margin-bottom:60px}.Error-module__error-screen___3Bg7s .Error-module__wrapper___mB-zW h2{text-align:center}.Error-module__error-screen___3Bg7s .Error-module__wrapper___mB-zW p{text-align:center;color:#b4bac3}", ""]);

// exports
exports.locals = {
	"error-screen": "Error-module__error-screen___3Bg7s",
	"wrapper": "Error-module__wrapper___mB-zW"
};